import gsap from "gsap";
const prSections = document.querySelectorAll(".pill-rotation");

prSections.forEach((section) => {
  const buttons = section.querySelectorAll("[data-tab-button]");
  const wrappers = section.querySelectorAll(".pill-lottie-wrapper");
  const pillCirclesSets = section.querySelectorAll(".pill-circles");
  const pillCenterContents = section.querySelectorAll(".pill-center-content");

  const titleExternal = section.querySelector(
    ".pill-content-title-external-desktop"
  );
  const paragraphExternal = section.querySelector(
    ".pill-content-paragraph-external"
  );
  const desktopContent = section.querySelector(".pill-lottie-content");
const desktopButton = section.querySelector(".pill-lottie-button a");

  const teal = "#3ABCCE";
  const green = "#78BE21";

  let previousIndex = 0;

  function updateCircles(circles, activeIndex) {
    circles.forEach((circle, i) => {
      circle.style.backgroundColor = i === activeIndex ? green : teal;
    });
  }

  function updateCenterContent(container, index) {
    const titleEl = container.querySelector(".pill-content-title");
    const innerEl = container.querySelector(".pill-content-inner");
    if (!titleEl || !innerEl) return;

    const innerContent = qualitysteps[index]["inner content"] || "";
    titleEl.textContent = qualitysteps[index]["inner"]
      ? qualitysteps[index]["inner"].toUpperCase()
      : qualitysteps[index].title.toUpperCase();

    innerEl.textContent = innerContent;

    const svgWrapper = container.parentElement.querySelector(".svg-wrapper");
    if (svgWrapper) {
      const rotationAngle = index * 90;
      svgWrapper.style.transform = `rotate(${rotationAngle - 10}deg)`;
    }
  }

  function animateDesktopContent(index) {
    if (!desktopContent || !titleExternal || !paragraphExternal) return;

    const direction = index > previousIndex ? 1 : -1;
    const offset = 50 * direction;

    gsap.to(desktopContent, {
      y: offset,
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        titleExternal.textContent = qualitysteps[index].title;
        paragraphExternal.textContent = qualitysteps[index].paragraph;

        // Update button link if it exists
        if (desktopButton && qualitysteps[index].btn_link) {
          desktopButton.href = qualitysteps[index].btn_link.url;
          desktopButton.textContent = qualitysteps[index].btn_link.title;
        }

        gsap.fromTo(
          desktopContent,
          { y: -offset, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.3 }
        );
      },
    });
  }

  function setActiveStep(index) {
    buttons.forEach((btn, i) => {
      btn.classList.toggle("bg-navy", i === index);
      btn.classList.toggle("!text-teal", i === index);
    });

    pillCirclesSets.forEach((circlesContainer) => {
      const circles = circlesContainer.querySelectorAll(".pill-circle");
      updateCircles(circles, index);
    });

    pillCenterContents.forEach((centerContent) => {
      updateCenterContent(centerContent, index);
    });

    animateDesktopContent(index);
    previousIndex = index;
  }

  function handleAccordion(index) {
    const isMobile = window.innerWidth < 1024;
    if (!isMobile) return;

    const clickedWrapper = buttons[index].closest(".pill-lottie-wrapper");
    const isActive = clickedWrapper.classList.contains("mobile-active");

    wrappers.forEach((wrapper) => {
      wrapper.classList.remove("mobile-active");
      const content = wrapper.querySelector("[data-mobile-content]");
      if (content) content.style.height = "0px";
    });

    if (!isActive) {
      clickedWrapper.classList.add("mobile-active");
      const content = clickedWrapper.querySelector("[data-mobile-content]");
      if (content) {
        content.style.height = content.scrollHeight + "px";
      }
    }
  }

  setActiveStep(0);

  buttons.forEach((btn, idx) => {
    btn.addEventListener("click", () => {
      setActiveStep(idx);
      handleAccordion(idx);
    });
  });

  pillCirclesSets.forEach((circlesContainer) => {
    const circles = circlesContainer.querySelectorAll(".pill-circle");
    circles.forEach((circle) => {
      const idx = parseInt(circle.getAttribute("data-step"));
      circle.addEventListener("click", () => {
        setActiveStep(idx);
      });
    });
  });
});

// const section = document.getElementById("quality_steps");
// if (!section) return;
